import AppBar from "@material-ui/core/AppBar";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import SwipeableViews from "react-swipeable-views";
//import Box from "@material-ui/core/Box";
import Configuracion from "./Configuracion";
import SnackBar from "../../SnackBar";

import Manual from "./Manual";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {/** Modificacion 3/3/2020 */}
      {Number(value) === Number(index) && <div>{children}</div>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

export default function FullWidthTabs() {
  //const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };
  const handleClose = () => {
    setOpen(!open);
  };
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <div style={{ width: "100%", marginTop: "10px", height: "500px" }}>
      <Typography variant="h5" gutterBottom>
        Configuracion
      </Typography>

      <SnackBar
        open={open}
        handleClick={handleClick}
        handleClose={handleClose}
      />

      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Configuracion" {...a11yProps(0)} />
          <Tab label="Ayuda" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Configuracion handleClick={handleClick} handleClose={handleClose} />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Manual />
        </TabPanel>
      </SwipeableViews>
    </div>
  );
}
